<template functional>
    <div>
        <p>Stop the customer's active subscriptions and cancels renewals. Sets the end time to when the action runs.</p>
    </div>
</template>

<script>
    export default {
        name: 'stop-subscriptions-summary',
    };
</script>
